import { Typography } from "@mui/material";
import { useState } from "react";
import React from "react";
import { useViewStudentAtd } from "../../assets/api/useTrainerGetApi";
import { useDialog } from "../../shared/hook/useDialog";
import MainDialogBox from "../../shared/components/Dialog/MainDialogBox";
import { Box } from "@mui/material";
import { CustomBadge } from "../../shared/utils/Badge";
import { Constants } from "../../shared/constants";
import TableFilterTemplate from "./TableFilterTemplate";


export const useStudentColumnwithDialog = () => {
    const [filters, setFilters] = useState({});
    const [userId, setUserId] = useState("")
    const [courseId, setCourseId] = useState("")
    const [apartmentId, setApartmentId] = useState("")
    const { data: studentAtd, isLoading: isStudentAtdLaoding } = useViewStudentAtd({ user_id: userId, apartmentId: apartmentId, course_id: courseId, ...filters })
    const { open, handleClickOpen, handleClose } = useDialog();
    const viewStudentAtd = studentAtd?.data?.map((item, index) => ({
        id: index + 1,
        attendance_date: item?.attendance_date,
        attendance_status: item?.attendance_status,
        course_name: item?.title
    })) || [];
    const studentColumns = [
        {
            field: "id",
            headerName: "Sr No",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "lastname",
            headerName: "Students Name",
            flex: 1.5,
            renderCell: (params) => (
                <Box my={1}> <Typography variant="body2">{params.value}</Typography></Box>
            ),
        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => (<Typography variant="body2">{params.value}</Typography>),
        },
        {
            field: "title",
            headerName: "Course Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },

        {
            field: "viewAttendance",
            headerName: "View Attendance",
            flex: 1,
            renderCell: (params) => {
                const student_id = params?.row?.user_id;
                const apartment_id = params?.row?.apartment_id;
                const course_id = params?.row?.course_id;
                return <CustomBadge
                    icon={<img src={Constants.customIcon.ViewStudent} alt="view Student" width={"20px"} />}
                    text={"Tap to View"}
                    textcolor={"blue.main"}
                    onClick={() => { setUserId(student_id); setApartmentId(apartment_id); setCourseId(course_id); handleClickOpen(); }}
                />
            },
        },
    ];

    const studentColumns1 = [
        {
            field: "id",
            headerName: "Sr No",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "attendance_date",
            headerName: "Date",
            flex: 1.5,
            renderCell: (params) => (
                <Box my={1}>
                    <Typography variant="body2">{params.value}</Typography>

                </Box>
            ),
        },
        {
            field: "course_name",
            headerName: "Course Name",
            flex: 1,
            renderCell: (params) => (
                <Box>
                    <Typography variant="body2">{params.value}</Typography>

                </Box>
            ),
        },
        {
            field: "attendance_status",
            headerName: "Attendance",
            flex: 1,
            renderCell: (params) => {
                if (params.value == 1) {
                    return <Typography variant="body2" sx={{ color: "success.main" }}>Present</Typography>;
                }
                else {
                    return <Typography variant="body2" sx={{ color: "error.main" }}>Absent</Typography>
                }
            }
        },

    ];
    const dialogJSX = (
        <MainDialogBox open={open} handleClose={handleClose}>
            <TableFilterTemplate
                title="View Student"
                columns={studentColumns1}
                rowsData={viewStudentAtd || []}
                isLoading={isStudentAtdLaoding}
            // filterInitialValues={filters}
            // filterReset={() => setFilters({})}
            // onApplyFilters={(f) => setFilters(f)}
            // renderFilterFields={() => (
            //     <>

            //     </>
            // )}
            />

        </MainDialogBox>
    );

    return { studentColumns, dialogJSX };
};


